import Icon from "@ant-design/icons";

export { default as CloseOutlined } from "@ant-design/icons/CloseOutlined";

export { default as MenuOutlined } from "@ant-design/icons/MenuOutlined";

export { default as PushpinOutlined } from "@ant-design/icons/PushpinOutlined";

export { default as PushpinFilled } from "@ant-design/icons/PushpinFilled";

export { default as SyncOutlined } from "@ant-design/icons/SyncOutlined";

export { default as ArrowLeftOutlined } from "@ant-design/icons/ArrowLeftOutlined";

export { default as UpOutlined } from "@ant-design/icons/UpOutlined";

export { default as DownOutlined } from "@ant-design/icons/DownOutlined";

export { default as RightOutlined } from "@ant-design/icons/RightOutlined";

export { default as ExclamationCircleFilled } from "@ant-design/icons/ExclamationCircleFilled";

export { default as NumberOutlined } from "@ant-design/icons/NumberOutlined";

export { default as PercentageOutlined } from "@ant-design/icons/PercentageOutlined";

export default Icon;
